export default "/acfdf2704e412c85fb550b6408622629b62bf7b2/1c51a79398276ba6cc677c7e60cd4bfb.png";